import * as reportPartsSalesJapanData from './reportPartsSalesJapanData';
const Reducers = {
  ...reportPartsSalesJapanData,
};
export default Reducers;
